// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/__fixtures__/growth-score.fixtures.ts (ADAPT: the check names and what each measures only; no sample numbers)
// source: template-project@7007a338a apps/backoffice/src/pages/onboarding-v2/growth-score/growth-score-model.ts (ADAPT: the dimension names and radar labels)
/**
 * The names the pages show for the BFF's keys. The BFF returns numbers and keys; TP's names stay here, keyed by the same
 * keys, so a check or a dimension can never be shown without a name.
 */
import type { CheckKey, DimensionKey } from '@/contracts/onboarding-session'

export interface CheckLabel {
  name: string
  /** What the check measures, under its name in the "How we measured it" tables. */
  sub?: string
}

export const CHECK_LABELS = {
  creative_diversity: { name: 'Creative diversity' },
  winners_that_last: { name: 'Winners that last' },
  testing_velocity: { name: 'Testing velocity' },
  audience_fit: { name: 'Audience fit' },
  partnership_ads: { name: 'Partnership ads' },
  aov_levers: { name: 'AOV levers', sub: 'bundles, multi-unit, free-shipping bar' },
  landing_strategy: { name: 'Landing strategy', sub: 'offer in the first screen, page built for the ad' },
  checkout_friction: { name: 'Checkout friction', sub: 'steps from ad to payment, express pay' },
  post_purchase_upsell: { name: 'Post-purchase upsell', sub: 'one-click after payment' },
  subscription: { name: 'Subscription', sub: 'subscribe & save on the product page' },
  tiktok_shop: { name: 'TikTok Shop' },
  creators: { name: 'Creators selling or talking about you' },
  account_reach: { name: 'Account reach' },
  tiktok_ads: { name: 'TikTok Ads' },
  live_shopping: { name: 'LIVE shopping' },
  seo: { name: 'Non-brand organic' },
  sem: { name: 'Brand defense' },
  ai: { name: 'AI visibility' },
  agent: { name: 'Agent readiness' },
  welcome_series: { name: 'Welcome series' },
  abandoned_cart: { name: 'Abandoned cart' },
  discount_dependence: { name: 'Discount dependence' },
  sms_capture: { name: 'SMS capture' },
  paid_channels: { name: 'Paid channels beyond Meta' },
  meta_concentration: { name: 'Meta concentration' },
  amazon: { name: 'Amazon' },
} as const satisfies Record<CheckKey, CheckLabel>

export const DIMENSION_LABELS = {
  ads: { name: 'Ads', short: 'Ads' },
  funnel: { name: 'Funnel', short: 'Funnel' },
  tiktok: { name: 'TikTok Organic & Shop', short: 'TikTok' },
  search: { name: 'Search & AI', short: 'Search & AI' },
  email: { name: 'Retention (Email & SMS)', short: 'Retention' },
  omni: { name: 'Omnichannel', short: 'Omnichannel' },
} as const satisfies Record<DimensionKey, { name: string; short: string }>
